import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row, DatePicker } from "antd";
import axios from "axios";
import "./Pages.css";
import ProdutosVendidosPrintModal from "../relatorios/ProdutosVendidosPrintModal";
import moment from "moment-timezone";
import numeral from "numeral";
import { getUsuario } from "../utils/LoginManager";
import FiltrosForm from '../components/FiltrosForm';
import ProdutosVendidosClientesForm from '../components/ProdutosVendidosClientesForm';
import Colors from "../utils/Colors";

const dateFormat = 'DD/MM/YYYY'
const { RangePicker } = DatePicker;
const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,

    qtdeItens1: 0,
    qtdeItens2: 0,
    vlrItens: 0,

    formClientesVisivel: false,

    formFiltroVisivel: false,
    filtros: {
      tipoTela: 'PV',
      buscaOrdem: { campo: 'prod_descricao', ordem: 'ASC' },
      buscaDataIni: moment(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaMes: 0,
      buscaAno: 0,
      buscaPessoa: { key: '0', },
      buscaUsuario: { key: '0', },
      buscaMunicipio: { key: '0', },
      buscaGrupoProduto: { key: '0' },
      buscaProduto: { key: '0' },
      buscaTipo: { key: 'X' },
      buscaControle: '',
      buscaAtividade: { key: '0', },
      buscaTipoAtiv: { key: 'X' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    }, this.getListaRegistros);
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      }, this.getListaRegistros)
    }
  }


  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true, qtdeItens1: 0, qtdeItens2: 0, vlrItens: 0 });
    const { pagina, limite } = this.state;

    const { buscaOrdem, buscaDataIni, buscaDataFim, buscaPessoa, buscaUsuario, buscaMunicipio,
      buscaGrupoProduto, buscaProduto } = this.state.filtros;

    if ((buscaDataIni) && (buscaDataFim)) {

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      axios
        .get('/vendas/listaProdutosVendidos', {
          params: {
            page: pagina,
            limite: limite,
            campoOrdem: buscaOrdem.campo,
            tipoOrdem: buscaOrdem.ordem,
            pessoa: buscaPessoa.key,
            cidade: buscaMunicipio.key,
            vendedor: buscaUsuario.key,
            grupo: buscaGrupoProduto.key,
            produto: buscaProduto.key,
            dataIni,
            dataFim,
          }
        })
        .then(response => {
          const { data, total, current_page, per_page } = response.data.dados;
          this.setState({
            listaRegistros: data,
            carregando: false,
            total: total,
            pagina: current_page,
            limite: Number(per_page),

            qtdeItens1: response.data.qtdeItens1 ? response.data.qtdeItens1 : 0,
            qtdeItens2: response.data.qtdeItens2 ? response.data.qtdeItens2 : 0,
            vlrItens: response.data.vlrItens ? response.data.vlrItens : 0,
          });

        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });
    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }

  };




  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({ [id]: value },
      this.getListaRegistros
    );
  };


  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaOrdem: this.state.filtros.buscaOrdem,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaMes: this.state.filtros.buscaMes,
        buscaAno: this.state.filtros.buscaAno,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaUsuario: this.state.filtros.buscaUsuario,
        buscaMunicipio: this.state.filtros.buscaMunicipio,
        buscaGrupoProduto: this.state.filtros.buscaGrupoProduto,
        buscaProduto: this.state.filtros.buscaProduto,
        buscaTipo: this.state.filtros.buscaTipo,
        buscaControle: this.state.filtros.buscaControle,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros(filtros)
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };


  renderCodProduto = (data, registro) => {
    return (
      <span>
        <Tooltip title="Exibir Clientes desse Produto">
          <a onClick={() => this.onVizualizarClick(registro)}>
            {registro.prod_codigo}
          </a>
        </Tooltip>
      </span>
    )
  }

  onCancelarClick = () => {
    this.setState({
      formClientesVisivel: false,
    });
  }

  onVizualizarClick = registro => {
    // console.log('onVizualizarClick 11');
    const { buscaOrdem, buscaDataIni, buscaDataFim, buscaPessoa, buscaUsuario, buscaMunicipio } = this.state.filtros;

    if ((buscaDataIni) && (buscaDataFim)) {

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      this.setState({ carregando: true });
      axios
        .get('/vendas/listaProdutosClientesVendidos', {
          params: {
            pessoa: buscaPessoa.key,
            cidade: buscaMunicipio.key,
            vendedor: buscaUsuario.key,
            produto: registro.prod_idf,
            dataIni,
            dataFim,
            print: 1,
          }
        })
        .then(response => {
          const { data } = response;
          // console.log('onVizualizarClick: ', data);
          this.setState({
            formClientesVisivel: true,
            registroSelecionado: data,
            carregando: false,
          })
        })
        .catch(error => {
          console.error(error.response);
          this.setState({
            carregando: false,
          })
        })
    }
  };




  renderData = (data, registro) => {
    let dataMoment = '';
    if ((registro.ultVenda) && (registro.ultOS)) {
      if (moment(registro.ultVenda) > moment(registro.ultOS)) {
        dataMoment = moment(registro.ultVenda);
      } else {
        dataMoment = moment(registro.ultOS);
      }
    } else if (registro.ultVenda) {
      dataMoment = moment(registro.ultVenda);
    } else if (registro.ultOS) {
      dataMoment = moment(registro.ultOS);
    }
    return (
      <span>
        {dataMoment ? dataMoment.format('DD/MM/YYYY') : ''}
      </span>
    )
  }


  onOrdenarListaClick = (column) => {
    const { filtros } = this.state;
    const ordem = filtros.buscaOrdem.campo && filtros.buscaOrdem.campo === column.dataIndex ? (filtros.buscaOrdem.ordem && filtros.buscaOrdem.ordem === 'ASC' ? 'DESC' : 'ASC') : 'ASC';
    filtros['buscaOrdem'] = { campo: column.dataIndex, ordem };
    this.setState({
      filtros,
      pagina: 1,
    }, this.getListaRegistros)
  };

  renderTitulo = (col) => {
    return (
      <Tooltip title="Clique para Ordenar"><div style={{ background: "#ececec", cursor: 'pointer', padding: 2, marginLeft: -5, marginRight: -5 }}>{col}</div></Tooltip>
    );
  };



  renderValor = (vlr) => {
    return (
      <span> {numeral(vlr).format('0,000.00')} </span>
    );
  };


  renderValorUN1 = (vlr, registro) => {
    return (
      <span> {numeral(registro.vlrItens / registro.qtdeItens).format('0,000.00')} </span>
    );
  };


  renderValorUN2 = (vlr, registro) => {
    return (
      <span> {registro.qtdeItens2 ? numeral(registro.vlrItens / registro.qtdeItens2).format('0,000.00') : ''} </span>
    );
  };

  renderPercVendas = (vlr) => {
    return (
      <span> {numeral(vlr).format('0,000.0000')} </span>
    );
  };

  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros)
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, filtros, total, pagina, limite, formFiltroVisivel, formClientesVisivel, registroSelecionado } = this.state;
    const { buscaAno, buscaMes } = this.state.filtros;

    // console.log('VendasVendedoresPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <h2 className="tituloPage">Produtos Vendidos</h2>
        <hr />
        <br />

        <Row>
          <div className="pageFiltro" style={{ height: 20 }}>
            <Col xs={24} >

              <Row xs={24} style={{}}>
                <Col xs={2} style={{ width: 110, marginTop: -7 }}>
                  <Button
                    onClick={this.onAbrirFiltroClick}
                    className="pageFiltro-filtrar"
                    style={{ marginRight: 15 }}
                  >
                    Filtrar
                  </Button>
                </Col>

                <FiltrosForm
                  visivel={formFiltroVisivel}
                  onFiltrarClick={this.onFiltrarClick}
                  onCancelarFiltroClick={this.onCancelarFiltroClick}
                  filtros={filtros}
                />

                <ProdutosVendidosClientesForm
                  visivel={formClientesVisivel}
                  onCancelarClick={this.onCancelarClick}
                  registroSelecionado={registroSelecionado}
                />

                <Col xs={2} style={{ width: 110, marginTop: -7 }}>
                  <ProdutosVendidosPrintModal
                    filtros={filtros}
                    qtdeItens1={this.state.qtdeItens1}
                    qtdeItens2={this.state.qtdeItens2}
                    vlrItens={this.state.vlrItens}
                    periodo={this.state.filtros.buscaDataIni + ' a ' + this.state.filtros.buscaDataFim}
                  />
                </Col>

                <Col xs={24} sm={12} style={{ marginTop: -20 }}>
                  <Col xs={24} sm={6} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                    <Row><span style={{ fontWeight: "bold" }}>Qtde Vendida 1</span></Row>
                    <Row><span>{this.renderValor(this.state.qtdeItens1)}</span></Row>
                  </Col>
                  <Col xs={24} sm={6} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                    <Row><span style={{ fontWeight: "bold" }}>Qtde Vendida 2</span></Row>
                    <Row><span>{this.renderValor(this.state.qtdeItens2)}</span></Row>
                  </Col>
                  <Col xs={24} sm={6} style={{ margin: 5, padding: 3, textAlign: "center", background: Colors.primaryLight, color: "white", borderRadius: 3 }} >
                    <Row><span style={{ fontWeight: "bold" }}>Valor Total</span></Row>
                    <Row><span>R$ {this.renderValor(this.state.vlrItens)}</span></Row>
                  </Col>
                </Col>
              </Row>

            </Col>

          </div>
        </Row>

        <Row>
          <div style={{ marginTop: 10 }}>
            <Table
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              // scroll={{ x: 600 }}
              rowKey={(registro => registro.prod_codigo)}
            >
              <Column
                key="prod_codigo"
                dataIndex="prod_codigo"
                title={this.renderTitulo("Produto")}
                width={"7%"}
                align="left"
                className="listaCadastro"
                render={this.renderCodProduto}
              />
              <Column
                key="prod_descricao"
                dataIndex="prod_descricao"
                title={this.renderTitulo("Descrição do Produto")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={"20%"}
                align="left"
                className="listaCadastro"
              />



              <Column
                key="qtdeItens"
                dataIndex="qtdeItens"
                title={this.renderTitulo("Qtde Vendida 1")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={"10%"}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="med_descricao1"
                dataIndex="med_descricao1"
                title={this.renderTitulo("UN 1")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={"5%"}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="vlrItens"
                dataIndex="vlrItens"
                title={this.renderTitulo("Valor Unit 1")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValorUN1}
                width={"10%"}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="qtdeItens2"
                dataIndex="qtdeItens2"
                title={this.renderTitulo("Qtde Vendida 2")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={"10%"}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="med_descricao2"
                dataIndex="med_descricao2"
                title={this.renderTitulo("UN 2")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                width={"5%"}
                align="center"
                className="listaCadastro"
              />
              <Column
                key="vlrItens1"
                dataIndex="vlrItens1"
                title={this.renderTitulo("Valor Unit 2")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValorUN2}
                width={"10%"}
                align="right"
                className="listaCadastro"
              />

              <Column
                key="vlrItens"
                dataIndex="vlrItens"
                title={this.renderTitulo("Valor Total")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderValor}
                width={"10%"}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="percVendas"
                dataIndex="percVendas"
                title={this.renderTitulo("% nas Vendas")}
                onHeaderCell={(column) => { return { onClick: () => { this.onOrdenarListaClick(column); } }; }}
                render={this.renderPercVendas}
                width={"10%"}
                align="right"
                className="listaCadastro"
              />

            </Table>
          </div>
        </Row>

      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/ProdutosVendidosPage.js